<!-- eslint-disable consistent-return -->
/* eslint-disable max-len */
<template>
  <div>
    <div class="ui-grid" style="height: 200px" v-if="!testResult">
      Fetching sociogram result, please wait...
    </div>
    <div class="ui grid" v-if="testResult">
      <div class="row">
        <h1 class="ui huge header">
          Sociometric Report for class {{ testResult.class.name }}
        </h1>
      </div>
      <div class="ui divider"></div>
      <div class="row">
        <test-class-culture v-bind:test-result="testResult" />
      </div>
      <div class="row">
        <p v-if="testResult.progress !== 100" class="ui negative message">
          The Nominations have not yet been completed by everyone in the class.
          Current progress: {{ testResult.progress }}%
        </p>
        <p v-else class="ui positive message">
          The Nominations have been completed by all students.
        </p>
      </div>
      <div class="row">
        <table class="ui striped selectable table">
          <thead>
            <tr>
              <th style="cursor: pointer" v-on:click="setOrderBy('lastName')">
                <span><u>Last name</u>
                  <i v-if="orderBy === 'lastName' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'lastName' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('firstName')">
                <span><u>First name</u>
                  <i v-if="orderBy === 'firstName' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'firstName' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
              <th>
                <span><u>Initials</u>
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('socialImpact')">
                <span><u>Social impact</u>
                  <i v-if="
                    orderBy === 'socialImpact' && orderDirection === 'asc'
                  " class="angle up icon" />
                  <i v-if="
                    orderBy === 'socialImpact' && orderDirection === 'desc'
                  " class="angle down icon" />
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('socialPreference')">
                <span><u>Social preference</u>
                  <i v-if="
                    orderBy === 'socialPreference' && orderDirection === 'asc'
                  " class="angle up icon" />
                  <i v-if="
                    orderBy === 'socialPreference' &&
                    orderDirection === 'desc'
                  " class="angle down icon" />
                </span>
              </th>
              <th>
                Classification(s)
                <sui-button icon="question circle" v-on:click="showClassificationLegend($event, null)" />
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('groupLabel')">
                <span><u>Team number</u>
                  <i v-if="orderBy === 'groupLabel' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'groupLabel' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="students.length == 0">
              <td></td>
              <td colspan="4">No students found</td>
            </tr>
            <tr v-else v-for="result in students" style="cursor: pointer" v-bind:key="result.student.id"
              v-on:click="showDetailsModal(result)" title="Click to see the result details the student">
              <td>{{ result.student.lastName }}</td>
              <td>{{ result.student.firstName }}</td>
              <td>{{ result.student.initials }}</td>
              <td>{{ result.socialImpact }}</td>
              <td>{{ result.socialPreference }}</td>
              <td>
                <span v-for="classification in result.classifications" v-bind:key="classification">
                  <a v-if="classification == 'Liked'" v-on:click="showClassificationLegend($event, 'L')"
                    class="ui purple label">L
                  </a>
                  <a v-if="classification == 'OneLikeReceived'" v-on:click="showClassificationLegend($event, '1LR')"
                    class="ui grey label">1LR
                  </a>
                  <a v-if="classification == 'Unchosen'" v-on:click="showClassificationLegend($event, 'UN')"
                    class="ui grey label">UN
                  </a>
                  <a v-if="classification == 'Rejected'" v-on:click="showClassificationLegend($event, 'R')"
                    class="ui yellow label">R
                  </a>
                  <a v-if="classification == 'Neglected'" v-on:click="showClassificationLegend($event, 'N')"
                    class="ui green label">N
                  </a>
                  <a v-if="classification == 'Controversial'" v-on:click="showClassificationLegend($event, 'C')"
                    class="ui teal label">C
                  </a>
                  <a v-if="classification == 'Average'" v-on:click="showClassificationLegend($event, 'A')"
                    class="ui brown label">A
                  </a>
                  <a v-if="classification == 'Unclassified'" v-on:click="showClassificationLegend($event, 'UC')"
                    class="ui blue label">UC
                  </a>
                </span>
              </td>
              <td>{{ result.groupLabel }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div>
          <sui-dropdown placeholder="Select the team size" selection name="group-size" :options="groupSizes"
            v-model="group.size" />
          <sui-button content="Update team size" positive icon="users" v-on:click="formGroups" />
          <sui-button content="Generate team list" secondary icon="users" v-on:click="generateTeamListReport" />
        </div>
      </div>
      <div class="row" style="min-height: 500px"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TestClassCulture from '@/components/tests/TestClassCulture';
import testsApi from '@/api/tests';

export default {
  name: 'TestResultShare',
  components: { TestClassCulture },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isAdmin: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Administrator' || this.user.profile.role === 'TeacherAdministrator');
      },
    },
    students() {
      const sortedStudents = this.testResult.students;
      switch (this.orderBy) {
        case 'lastName':
          sortedStudents.sort((a, b) => {
            if (a.student.lastName < b.student.lastName) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.lastName > b.student.lastName) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'firstName':
          sortedStudents.sort((a, b) => {
            if (a.student.firstName < b.student.firstName) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.firstName > b.student.firstName) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'dateOfBirth':
          sortedStudents.sort((a, b) => {
            if (a.student.dateOfBirth < b.student.dateOfBirth) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.dateOfBirth > b.student.dateOfBirth) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'socialImpact':
          sortedStudents.sort((a, b) => {
            if (a.socialImpact < b.socialImpact) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.socialImpact > b.socialImpact) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'socialPreference':
          sortedStudents.sort((a, b) => {
            if (a.socialPreference < b.socialPreference) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.socialPreference > b.socialPreference) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'groupLabel':
          sortedStudents.sort((a, b) => {
            if (a.group < b.group) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.group > b.group) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        default:
          break;
      }
      return sortedStudents;
    },
  },
  data() {
    return {
      testResult: null,
      orderBy: 'lastName',
      orderDirection: 'asc',
      result: null,
      group: { size: 3 },
      groupSizes: [
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
      ],
    };
  },
  created() {
    this.$store
      .dispatch('getTestResult', {
        id: this.$route.params.id,
        size: this.group.size,
      })
      .then((response) => {
        this.testResult = response.data;
      });
  },
  methods: {
    showClassificationLegend(event, category) {
      event.stopPropagation();
      this.$store.dispatch('showClassificationLegend', category);
    },
    hideClassificationLegend() {
      this.$store.dispatch('hideClassificationLegend');
    },
    showDetailsModal(result) {
      const testResultCopy = JSON.parse(JSON.stringify(this.testResult));
      testResultCopy.students.forEach((student) => {
        student.choices = student.choices.filter(
          // eslint-disable-next-line arrow-parens
          (choice) => choice.targetStudent.id === result.student.id,
        );
      });
      this.$store.dispatch('setTestResult', testResultCopy);

      this.$store.dispatch('setTestResultDetails', result);
      this.$store.dispatch('showTestResultDetailsNew');
    },
    hideDetailsModal() {
      this.$store.dispatch('hideTestResultDetailsNew');
    },
    formGroups() {
      this.$store
        .dispatch('getTestResult', {
          id: this.$route.params.id,
          size: this.group.size,
        })
        .then((response) => {
          this.testResult = response.data;
        });
    },
    generateReport() {
      this.$store.dispatch('showLoader');
      testsApi
        .generateReport(this.$route.params.id)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
    generateTeamListReport() {
      this.$store.dispatch('showLoader');
      testsApi
        .generateTeamListReport(this.$route.params.id, this.group.size)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
    setOrderBy(column) {
      if (this.orderBy === column) {
        this.orderDirection = this.orderDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.orderBy = column;
        this.orderDirection = 'asc';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestResultShare.vue